<template>
  <div>
    <b-row v-if="show" class="no-gutters">
      <b-col class="d-flex justify-content-end shadow p-3">
        <b-button variant="primary" @click="addSceneClicked">
          {{ $t('add-scene') | capitalize }}
        </b-button>
        <b-button @click.prevent="toggleEditMode()" class="ml-3">
          <template v-if="scene.isEditModeEnabled">
            <font-awesome-icon icon="check-circle" />
            {{ $t('done') | capitalize }}
          </template>
          <template v-else>
            <font-awesome-icon icon="pen" />
            {{ $t('edit') | capitalize }}
          </template>
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import BaseContextMenuMixin from '@/components/context-menus/BaseContextMenu';
import eventBus from '@/components/utils/slideout-panel/eventBus';

export default {
  name: 'Scenes',
  mixins: [
    BaseContextMenuMixin,
  ],
  computed: {
    ...mapState('app', [
      'scene',
    ]),
  },
  methods: {
    ...mapActions('app', [
      'setState',
    ]),
    addSceneClicked() {
      eventBus.$emit('addSceneClicked');
    },
    toggleEditMode() {
      const isEditModeEnabled = !this.scene.isEditModeEnabled;
      this.setState({ section: 'scene', setting: { isEditModeEnabled } });
    },
  },
};
</script>

<style scoped>

</style>
